import {
  LIST_SERVICE_TYPE_REQUEST,
  LIST_SERVICE_TYPE_SUCCESS,
  LIST_SERVICE_TYPE_FAIL,
  LIST_SERVICE_TYPE_SUMMARY_REQUEST,
  LIST_SERVICE_TYPE_SUMMARY_SUCCESS,
  LIST_SERVICE_TYPE_SUMMARY_FAIL,
  CREATE_SERVICE_TYPE_REQUEST,
  CREATE_SERVICE_TYPE_SUCCESS,
  CREATE_SERVICE_TYPE_FAIL,
  DETAIL_SERVICE_TYPE_REQUEST,
  DETAIL_SERVICE_TYPE_SUCCESS,
  DETAIL_SERVICE_TYPE_FAIL,
  UPDATE_SERVICE_TYPE_REQUEST,
  UPDATE_SERVICE_TYPE_SUCCESS,
  UPDATE_SERVICE_TYPE_FAIL,
  DELETE_SERVICE_TYPE_REQUEST,
  DELETE_SERVICE_TYPE_SUCCESS,
  DELETE_SERVICE_TYPE_FAIL,
  RESET_SERVICE_TYPE
} from '../../constants/service-type'

const initialState = {
  loading: false,
  serviceTypes: [],
  serviceTypesSummary: [],
  serviceType: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const serviceTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_TYPE_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceTypes: action.payload,
        pageable: action.pageable
      }
    case LIST_SERVICE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        serviceTypes: action?.dummy
      }
    case LIST_SERVICE_TYPE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_TYPE_SUMMARY_SUCCESS:
      return { ...state, loading: false, serviceTypesSummary: action.payload, error: null }
    case LIST_SERVICE_TYPE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_SERVICE_TYPE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_SERVICE_TYPE_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_SERVICE_TYPE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_SERVICE_TYPE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_SERVICE_TYPE_SUCCESS:
      return { ...state, loadingDetail: false, error: null, serviceType: action.payload }
    case DETAIL_SERVICE_TYPE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_SERVICE_TYPE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_SERVICE_TYPE_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_SERVICE_TYPE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_SERVICE_TYPE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_SERVICE_TYPE_SUCCESS:
      const serviceTypeIdDelete = action.payload
      const serviceTypesDelete = [...state.serviceTypes]

      const indexDelete = serviceTypesDelete.findIndex(
        (serviceType) => serviceType.id === serviceTypeIdDelete
      )
      serviceTypesDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, serviceTypes: serviceTypesDelete, eeror: null }
    case DELETE_SERVICE_TYPE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_SERVICE_TYPE:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default serviceTypesReducer
